import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSpacingHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 4.75h1.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2h-1.5M19.25 4.75h-1.5a2 2 0 0 0-2 2v10.5a2 2 0 0 0 2 2h1.5M12 8.75v6.5"
    />
  </svg>
);
export default SvgSpacingHorizontal;
